import { useQuery } from '@apollo/client';

import { cn } from 'src/lib/utils';
import { SidebarMenuBadge } from 'src/components/ui/sidebar';

import { GET_ACTIVE_RECOMMENDATION_COUNTS } from '../graphql/getActiveRecommendationCounts';

/**
 * Active-recommendation count for the sidebar nav item. Hidden at zero (and
 * while gated/unavailable); tinted when any HIGH-priority action is waiting.
 * Resolution mutations refetch ActiveRecommendationCounts to keep it live.
 */
export default function RecommendationsNavBadge() {
  const { data } = useQuery(GET_ACTIVE_RECOMMENDATION_COUNTS, {
    fetchPolicy: 'cache-and-network',
  });

  const counts = data?.getActiveRecommendationCounts;
  if (!counts?.total) return null;

  return (
    <SidebarMenuBadge className={cn(counts.high > 0 && 'font-semibold text-destructive')}>
      {counts.total > 99 ? '99+' : counts.total}
    </SidebarMenuBadge>
  );
}
